export const API_MODULE_CAMPAIGN = "CAMPAIGN"
export const APP_CAMPAIGN = "campaign"
export const MODULE_CAMPAIGNS = "campaigns"